import { lazy } from "react";

const UserClient = lazy(() => import("./UserClient"));

const clientRoutes = [
    {
      path: "/Client/UserClient",
      element: <UserClient />
    },
  ];
  
  export default clientRoutes;